import React, { FC, useEffect } from 'react';

import { Box } from '@src/atoms/Box';
import { Divider } from '@src/atoms/Divider';
import { Icon } from '@src/atoms/Icon';
import { Link } from '@src/atoms/Link';
import { Text } from '@src/atoms/Text';
import { TooltipNew } from '@src/atoms/TooltipNew';
import { Unit } from '@src/core/Unit';
import { AnyType } from '@src/models/common';

import { useSyncFilterValue } from '../../useSyncValue';
import { ISwipeDialogFilterTypeProps } from '../models';
import { getSelectedOptions } from './utils';
import { TControllerValue, TFilterSchemeOptions } from '../../models';
import { DATA_ELEM_ICON } from './consts';
import { isNotEmptyMessage } from '@src/utils/message';

import styles from './FilterSwipeDialogType@options.scss';
import { useOpenFilterByName } from '@src/hooks/useOpenFilterByName';

interface IFilterSwipeDialogTypeOptionsItemProps {
  renderOption: TFilterSchemeOptions['renderOption'];
  filterField: string;
  option: { id: number };
  index: number;
}

const FilterSwipeDialogTypeOptionsItem: FC<IFilterSwipeDialogTypeOptionsItemProps> = ({
  filterField,
  option,
  index,
  renderOption,
}) => {
  return renderOption ? (
    <>{renderOption(option, index)}</>
  ) : (
    <Text key={option.id} id="defeaultOptionValue" style={{ wordBreak: 'break-all' }} noOfLines={1} color="basicBlack">
      {option[filterField]}
    </Text>
  );
};

export const FilterSwipeDialogTypeOptions: FC<ISwipeDialogFilterTypeProps> = ({
  onOpen,
  isLast,
  filter,
  controller,
}) => {
  const { description, name, title, renderOption, filterField } = filter as TFilterSchemeOptions;
  const value = useSyncFilterValue({ controller, event: filter.name }) as TControllerValue<AnyType[]>;

  const handleClick = useOpenFilterByName(DATA_ELEM_ICON, onOpen, filter?.name);

  useEffect(() => {
    //Здесь мы загружаем опции только если есть значение
    value?.value && controller.loadOption(filter as TFilterSchemeOptions);
  }, [controller, filter, value]);

  useEffect(() => {
    //Здесь мы загружаем опции только если есть значение
    value?.value && controller.loadOption(filter as TFilterSchemeOptions);
  }, [controller, filter, value]);

  /** Текстовое обозначение выбранных опций */
  const selectedOptions = getSelectedOptions(filter as AnyType, value?.value);

  return (
    <>
      <Unit id="MobileFilterPropertyOption" entityCtx={{ objectId: name, entityId: `filter` }}>
        <Link id="MobileFilterPropertyOptionLink" onClick={handleClick}>
          <Box column gap={8} fullWidth>
            <Box fullWidth alignItems="center" justifyContent="spaceBetween" padding={16} gap={8}>
              <Box gap={8} justifyContent="spaceBetween" alignItems="center" fullWidth style={{ overflow: 'hidden' }}>
                <Text id="FilterPropertyName" color="basicGreySemiDark">
                  {title}
                </Text>

                {Array.isArray(selectedOptions) && selectedOptions.length > 0 && (
                  <Box gap={4} alignItems="center">
                    {selectedOptions.length === 1 ? (
                      <FilterSwipeDialogTypeOptionsItem
                        index={1}
                        option={selectedOptions[0]}
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        filterField={filterField!}
                        renderOption={renderOption}
                      />
                    ) : (
                      <Text
                        id="MobileFilterPropertyOptionCount"
                        size="caption"
                        color="basicWhite"
                        className={styles.count}
                      >
                        {selectedOptions.length}
                      </Text>
                    )}
                  </Box>
                )}
              </Box>
              <Box gap={16}>
                {isNotEmptyMessage(description) && (
                  <TooltipNew
                    trigger="click"
                    content={
                      <Text id="FilterPropertyNameTooltip" size="caption">
                        <div dangerouslySetInnerHTML={{ __html: description }} />
                      </Text>
                    }
                  >
                    <Icon name="circleOutlineQuestion" size="sm" data-elem={DATA_ELEM_ICON} />
                  </TooltipNew>
                )}

                <Box>
                  <Link id={'showOptions'}>
                    <Icon name="arrowRight" size="sm" />
                  </Link>
                </Box>
              </Box>
            </Box>
          </Box>
        </Link>
      </Unit>

      {!isLast && (
        <Box marginLeft={16} marginRight={16}>
          <Divider />
        </Box>
      )}
    </>
  );
};
